<template>
    <div>
        <my-form 
            class="form-page" 
            v-model="form" table 
            label-width="180px" 
            :submit-url="`${getGetters('ageUrl')}/FaBiao/ZbFile/`+processType+`cq/savebys.json`"
            :before-send="beforeSend"
            @cancle="cancleHandler">

                <el-form-item 
                    label="招标项目名称"
                    class="table-full-row">
                        {{formData.zbproname}}
                </el-form-item>

                <el-form-item
                    label="适用招标文件"
                    class="table-full-row prewrap"
                    key="by1"
                    prop="by1"
                    v-if="flag"
                    :rules="newRule('适用招标文件', 'required')">
                        <mybys-checkbox
                            model-str
                            str-spliter=";"
                            v-model="form.by1"
                            @change="checkZbfile(form.by1)"
                            :data="formData.zbfilelist"
                            :props="{label:'zbfilename',value:'zbfilecode'}">
                        </mybys-checkbox>
                </el-form-item>

                <el-form-item
                    label="招标文件"
                    class="table-full-row"
                    v-if="!flag">
                        <p v-for="item in formData.zbfilelist">
                            {{item.zbfilename}}（{{item.zbfilecode}}）
                        </p>
                </el-form-item>

                <el-form-item
                    v-if="formData.xtdq"
                    label="是否变更预算或保证金"
                    class="table-full-row">
                        <el-table :data="dataList" border>
                            <el-table-column
                                prop="bdname"
                                label="标段名称"
                                min-width="160">
                            </el-table-column>
                            <el-table-column
                                label="是否变更保证金"
                                min-width="100">
                                    <template slot-scope="scope">
                                        <my-radio
                                            v-model="scope.row.izbgbzj"
                                            :data="[{key:'1', value:'是'},{key:'0', value:'否'}]">
                                        </my-radio>
                                        <div v-if="scope.row.izbgbzj=='1'">
                                            <el-input 
                                                style="width:150px;margin-top:15px"
                                                type="number"
                                                v-model.number="scope.row.bgbzj" 
                                                placeholder="请输入内容">
                                            </el-input>万元 人民币
                                        </div>
                                        
                                    </template>
                            </el-table-column>
                            <el-table-column
                                label="是否变更预算"
                                min-width="100">
                                    <template slot-scope="scope">
                                        <my-radio
                                            v-model="scope.row.izbgys"
                                            :data="[{key:'1', value:'是'},{key:'0', value:'否'}]">
                                        </my-radio>
                                        <div v-if="scope.row.izbgys=='1'">
                                            <el-input 
                                                style="width:150px;margin-top:15px"
                                                type="number"
                                                v-model.number="scope.row.bgys" 
                                                placeholder="请输入内容">
                                            </el-input>万元 人民币
                                        </div>
                                        
                                    </template>
                            </el-table-column>
                        </el-table>
                </el-form-item>

                <el-form-item
                    label="澄清标题"
                    class="table-full-row"
                    prop="zbfilename"
                    :rules="newRule('澄清标题', 'required')">
                        <el-input
                            v-model.trim="form.zbfilename">
                        </el-input>
                </el-form-item>

                <el-form-item
                    label="投标文件递交截止时间"
                    prop="tbwjdjjztime"
                    :rules="newRule('投标文件递交截止时间', 'required')">
                        <el-date-picker
                            v-model="form.tbwjdjjztime"
                            :picker-options="datePickerOptions"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm"
                            format="yyyy-MM-dd HH:mm">
                        </el-date-picker>
                </el-form-item>

                <el-form-item
                    label="投标文件解密截止时间"
                    prop="tbwjjmjzsj"
                    :rules="newRule('投标文件解密截止时间', 'required')">
                        <el-date-picker
                            v-model="form.tbwjjmjzsj"
                            :picker-options="datePickerOptions"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm"
                            format="yyyy-MM-dd HH:mm">
                        </el-date-picker>
                </el-form-item>
                
                <el-form-item 
                    v-if="formData.ishbpsp=='1'"
                    label="是否推送河北省招标投标公共服务平台"
                    prop="ishbpsp"
                    :rules="newRule('是否推送河北省招标投标公共服务平台', 'required')">
                        <my-radio
                        v-model="form.ishbpsp"
                        :data="[{key:'1', value:'是'},{key:'0', value:'否'}]">
                        </my-radio>
                </el-form-item>

                 <el-form-item
                    label="质疑截止时间"
                    prop="questionendday"
                    :rules="newRule('质疑截止时间', 'required')">
                        <el-date-picker
                            v-model="form.questionendday"
                            :picker-options="datePickerOptions"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm"
                            format="yyyy-MM-dd HH:mm">
                        </el-date-picker>
                </el-form-item>

                <el-form-item
                    label="答疑澄清内容"
                    class="table-full-row">
                        <ueditor v-model="form.dycqcontent" />
                </el-form-item>

                <el-form-item
                    label="附件"
                    class="table-full-row">
                        <my-upload 
                            :file-guid="formData.qtfj|| ''" 
                            file-type=".jpg,.pdf,.zip,.rar,.doc,.docx"  
                            :file-size="1024">
                        </my-upload>
                </el-form-item>

                <el-form-item
                class="table-full-row"
                v-if="formData.izsjjt"
                label="招标澄清备案表"
                :rules="newRule('招标澄清备案表', 'required')">
                    <el-link type="primary" @click="mobandown" target="_blank">模板下载</el-link>
                    <my-upload 
                        :typecode="'wjcqbab'"
                        :file-guid="formData.babguid|| ''" 
                        file-type=".pdf"  
                        :file-size="1024">
                    </my-upload>
            </el-form-item>

                <template slot="btn" slot-scope="scope">
                    <el-button 
                        @click="saveHandler(1, scope.submitHandler)" 
                        type="primary" 
                        icon="el-icon-circle-check">
                            提交
                    </el-button>
                    <el-button 
                        @click="saveHandler(0, scope.submitHandler)" 
                        type="warning" 
                        icon="el-icon-remove-outline">
                            暂存
                    </el-button>

                    <el-button 
                        icon="el-icon-circle-close" 
                        @click="scope.cancleHandler">
                            取消
                    </el-button>

               
                </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import CaActivation from '@/components-sys/ca-activation'
import mybysCheckbox from '../components/mybys-checkbox'
export default {
    mixins: [ FORM_PAGE_MIXIN],
    components: {
        CaActivation,mybysCheckbox
    },
    data() {
        return{
            form:{
                zbproname:'',
                zbfilename:'',
                tbwjdjjztime:'',
                dycqcontent:'',
                by1:'',
                ishbpsp:'',
                questionendday:'',
            },
            formData:{},
            processType:'',
            type:'',
            isXt:'',
            flag:false,
            // 时间禁止之前
            datePickerOptions: {
                disabledDate(time) {
                    var today = new Date().pattern('yyyy/MM/dd');
                    return time.getTime() < new Date(today).getTime();
                }
            },

            dataList:[],
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        // 选择招标文件
        checkZbfile(val){
            var that = this;
            that.dataList = [];
            var flieList = val.split(';');
            flieList.forEach(function(item){
                that.formData.zbfilelist.forEach(function(obj){
                    if(item==obj.zbfilecode){
                        var initObj = { bdname:obj.bdname,bdcode:obj.bdcode,izbgys:'0',bgys:'',izbgbzj:'0',bgbzj:''}
                        that.dataList.push(initObj);
                    }
                })
            })
            console.log(that.dataList)
        },
       
        // 保存
        saveHandler(shbj,cb,type) {
            this.form.babguid = this.formData.babguid;
            this.form.shbj = shbj;
            this.form.scbj = '0';
            cb && cb();
        },
        beforeSend(send, deny){
            var that = this
            if(!this.form.tbwjdjjztime||!this.form.by1||!this.form.tbwjjmjzsj||!this.form.zbfilename){
                send();
                return
            }
            for(var i=0; i<that.dataList.length;i++){
                if(that.dataList[i].izbgbzj=='1'||that.dataList[i].izbgys=='1'){
                    if(that.dataList[i].bgbzj==''){
                        ShowMsg('请输入变更保证金内容');
                        return deny();
                    }
                    if(that.dataList[i].bgys==''){
                        ShowMsg('请输入变更预算内容');
                        return deny();
                    }
                }
            }
            that.form.updateJson = JSON.stringify(that.dataList)
            // 对比时间
            var limit = new Date(this.formData.limit).getTime();
            var jztime = this.form.tbwjdjjztime.replace("-","/").replace("-","/");
            var tbjztime = new Date(jztime).getTime();
            if(tbjztime<limit){
                this.$confirm('距离开标时间不足15日，请确认是否'+'<strong class="red">影响投标单位投标</strong>继续提交可以点击“确定”按钮！', '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    dangerouslyUseHTMLString: true,
                    type: 'warning',
                    callback:function (value,instance) {
                        if(value=='confirm'){
                            // 按类报名方法
                            $.get(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/isalbm/zbwj.json`,{
                                zbfilecode:that.form.by1,
                                t:Math.random()
                            }, data => {
                                if(data.result){
                                    that.$confirm('您选择的招标文件对应标段类型为'+'<strong class="red">按类报名</strong>项目，确认提交后将为您同步'+'<strong class="red">添加/更新</strong>该类别下所属的所有标段：'+'<strong class="red">'+data.msg+'</strong>'+'，是否继续？', '提示', {
                                        cancelButtonText: '取消',
                                        confirmButtonText: '确定',
                                        dangerouslyUseHTMLString: true,
                                        type: 'warning',
                                        callback:function (value,instance) {
                                            if(value=='confirm'){
                                                send();
                                            }else{
                                                return deny();
                                            }
                                        }
                                    })
                                }else{
                                    send();
                                }
                                
                            })
                        }else{
                            return deny();
                        }
                    }
                });
            }else{
                // 按类报名方法
                $.get(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/isalbm/zbwj.json`,{
                    zbfilecode:that.form.by1,
                    t:Math.random()
                }, data => {
                    if(data.result){
                        that.$confirm('您选择的招标文件对应标段类型为'+'<strong class="red">按类报名</strong>项目，确认提交后将为您同步'+'<strong class="red">添加/更新</strong>该类别下所属的所有标段：'+'<strong class="red">'+data.msg+'</strong>'+'，是否继续？', '提示', {
                            cancelButtonText: '取消',
                            confirmButtonText: '确定',
                            dangerouslyUseHTMLString: true,
                            type: 'warning',
                            callback:function (value,instance) {
                                if(value=='confirm'){
                                    send();
                                }else{
                                    return deny();
                                }
                            }
                        })
                    }else{
                        send();
                    }
                    
                })
            }
        },
         // 下载模板
        mobandown(){
            window.open("./static/bidding/files/河北省交通运输工程项目招标文件补遗澄清备案表.docx");
        }
    },
    created() {
        var that = this;
        that.isXt = that.getQuery('isXt');
        if(that.isXt=='1'){
            that.processType = 'xingtai/';
        }
        that.jspInit(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.processType+`cq/editbys.json`,that.detailExtra,(data, res) => {
           
            var form = data.zbwjmodel;
            form.by1 = form.by1 || '';
            form.procode = data.procode;
            form.zbprocode = data.zbprocode;
            form.zbproname = data.zbproname;
            that.form = form;
           
            that.formData = data;
            if(!that.formData.zbfilecode){
                that.flag = true;
            }
             if(that.formData.xtdq&&that.getQuery('id')){
                that.dataList.push({ 
                    bdname:data.zbfilelist[0].bdname,
                    bdcode:data.zbfilelist[0].bdcode,
                    izbgys:data.zbwjmodel.izbgys,
                    bgys:data.zbwjmodel.bgys,
                    izbgbzj:data.zbwjmodel.izbgbzj,
                    bgbzj:data.zbwjmodel.bgbzj
                })
            }
            
        });
        
    },
    mounted() {
        
    }
}
</script>

<style>
   .prewrap .el-checkbox__label{ white-space: pre-wrap; }
</style>
